<template>
    <div class="nav-wrapper">
        <div class="logo-container">
            <img :src="logoSrc" class="nav-logo" alt="logo"/>
            <span class="version-text">&nbsp;&nbsp;&nbsp;&nbsp;{{ version }}</span>
        </div>
        <div class="content">
            <el-menu :default-active="topMenu" class="menu-top" mode="horizontal"
                     @select="handleSelect">
                <el-menu-item index="top-logo">{{ $strings('word/notification') }}</el-menu-item>
                <el-submenu index="me-is">
                    <template slot="title">{{ username }}</template>
                    <el-menu-item index="me-center">{{ $strings('word/settings') }}</el-menu-item>
                    <el-menu-item index="me-logout">{{ $strings('word/logout') }}</el-menu-item>
                </el-submenu>
            </el-menu>
        </div>
        <el-drawer
            :title="$strings('word/settings')"
            :size="'24%'"
            :append-to-body="true"
            :visible.sync="drawer"
            direction="rtl">
            <div class="drawer-body">
                <h4>{{ $strings('word/change_password') }}</h4>
                <div class="password-wrapper">
                    <el-form ref="form" :model="formPass" label-width="80px" label-position="top">
                        <el-form-item :label="$strings('word/password_old')">
                            <el-input v-model="formPass.raw_password" type="password"></el-input>
                        </el-form-item>
                        <el-form-item :label="$strings('word/password_new')">
                            <el-input v-model="formPass.password" type="password"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onChangePass" size="small">{{ $strings('word/update') }}
                            </el-button>
                            <transition name="el-fade-in-linear">
                                <span class="success-text" v-show="changePassOK">Success</span>
                            </transition>
                        </el-form-item>
                    </el-form>
                </div>
                <h4>{{ $strings('word/change_timezone') }}</h4>
                <div class="timezone-wrapper">
                    <el-form ref="form2" :model="formTz" label-width="80px" label-position="top">
                        <el-form-item :label="$strings('word/timezone')">
                            <el-select v-model="formTz.tz" placeholder="" style="width:100%;">
                                <el-option v-for="(val, index) in tzs" :label="val.label" :key="index"
                                           :value="val.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onChangeTz" size="small">{{ $strings('word/update') }}
                            </el-button>
                            <transition name="el-fade-in-linear">
                                <span class="success-text" v-show="changeTzOK">Success</span>
                            </transition>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import LogoImg from "@/assets/logo.svg";
import {Timezones} from "@/utils/timezone";
import {GetItem, SaveItem} from "@/utils/storage";
import {API_STATUS_CODE, STORAGE_KEY_LOGIN_TZ, STORAGE_KEY_LOGIN_USER_NAME} from "@/config/config";
import {ToTitleChar} from "@/utils/str";
import {AdminChangePassword, AdminChangeTimezone, AdminLogoutDo} from "@/api/admin/api";
import {VERSION} from "@/config/config";

export default {
    name: "top-menu",
    data() {
        return {
            drawer: false,
            logoSrc: LogoImg,
            topMenu: "me-center",
            formPass: {},
            formTz: {tz: parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))},
            tzs: Timezones,
            changeTzOK: false,
            changePassOK: false,
            version: VERSION,
        }
    },
    computed: {
        username: function () {
            let name = GetItem(STORAGE_KEY_LOGIN_USER_NAME);
            return name ? ToTitleChar(name) : this.$strings('word/me_center');
        },
    },
    methods: {
        handleSelect(key, keyPath) {
            if (key === "me-center") {
                this.drawer = true;
            }
            if (key === "me-logout") {
                AdminLogoutDo().then(function () {
                    console.log('logout');
                    this.$router.push({'path': '/login'});
                }.bind(this));
                return
            }
            console.log(key, keyPath);
        },
        onChangePass() {
            AdminChangePassword().then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.changePassOK = true;
                    window.setTimeout(function () {
                        this.changePassOK = false;
                    }.bind(this), 2000)
                }
            })
        },
        onChangeTz() {
            AdminChangeTimezone({tz: this.formTz.tz}).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    SaveItem(STORAGE_KEY_LOGIN_TZ, this.formTz.tz);
                    this.changeTzOK = true;
                    window.setTimeout(function () {
                        this.changeTzOK = false;
                    }.bind(this), 2000)
                }
            });
        }
    }
}
</script>

<style scoped lang="scss">
@import "src/assets/css/var";

.nav-logo {
    height: 40px;
}

$color-border-base: #dcdfe6;

.nav-top {
    border-bottom: 1px solid $color-border-base;
}

.nav-wrapper {
    padding: 0 1em;
    display: flex;
    flex-direction: row;


    .logo-container {
        display: flex;
        align-items: center;
    }

    .content {
        display: flex;
        flex-grow: 1;
        justify-content: flex-end
    }
}

.menu-top {
    border-bottom: none;

    .el-menu-item.is-active {
        border-bottom: none;
        font-weight: bold;
    }
}

.drawer-body {
    padding: 0 2em 2em 2em;
}

.success-text {
    padding: 0 1em;
    color: #67C23A;
    font-weight: bold;
}

.version-text {
    font-size: 12px;
}

</style>